import type { BoardArtifactLink, BoardArtifacts } from '@nightshift/ui-types';

import { bytes, ciStatusWords, untilShort } from './format.ts';

/** What the card's artifacts button says on hover: how many, and where from. */
export function artifactsButtonTitle(artifacts: BoardArtifacts): string {
  const count = artifacts.key.length + artifacts.more.length;
  return `${count} ${count === 1 ? 'artifact' : 'artifacts'} from pipeline #${artifacts.pipelineId}`;
}

/**
 * The line under a link: size when known, and how long GitLab will keep it.
 *
 * "Expired" is said out loud rather than leaving a dead link to be discovered: an `expire_in`
 * of a week is what every Cell job sets, and a card can outlive it by months.
 */
export function artifactMeta(link: BoardArtifactLink, now: number): { text: string; expired: boolean } {
  const parts: string[] = [];
  if (link.sizeBytes !== null) parts.push(bytes(link.sizeBytes));
  let expired = false;
  if (link.expiresAt !== null) {
    if (link.expiresAt <= now) {
      expired = true;
      parts.push('expired');
    } else {
      parts.push(`expires in ${untilShort(link.expiresAt, now)}`);
    }
  }
  return { text: parts.join(' · '), expired };
}

/** Why a declared artifact has no link: the job ran and uploaded nothing. */
export function artifactUnavailable(link: BoardArtifactLink): string {
  return `not uploaded · ${link.job} ${ciStatusWords(link.jobStatus)}`;
}
